const Config = {
  BaseURL: 'https://api.cloudcabinet.jp/',
  tokenErrorMsg: '一定時間操作されなかったため、タイムアウトしました。\nログインし直してください。\n初めてログインされる方はそのままOKボタンをクリックしてください。',
  appVersion: '1.10.3 (437eece8)',
};

export default Config;
